import { Injectable, inject } from '@angular/core';
import { calculatePathScore } from '@functions';
import { BoxDetection } from '@models';
import { MetricsService, SimulationService } from '@services';
import { SceneStore } from '@stores';
import { metrics } from './metrics';

@Injectable({
  providedIn: 'root',
})
export class LigatingLoopMetricsService {
  private metricsService = inject(MetricsService);
  private sceneStore = inject(SceneStore);
  private simulationService = inject(SimulationService);

  metrics = metrics;

  trackGrasper(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'grasper');
  }

  trackLoop(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'loop');
  }

  finalizeMetrics() {
    this.metrics.time.value = this.simulationService.recordingTime();
    this.metrics.grasperPath.value = calculatePathScore({
      maxScore: 15,
      minValue: 40,
      maxValue: 150,
      value: this.metricsService.getToolDistance('grasper'),
    });
    this.metrics.ligatingLoopPath.value = calculatePathScore({
      maxScore: 15,
      minValue: 100,
      maxValue: 310,
      value: this.metricsService.getToolDistance('loop'),
    });

    this.sceneStore.updateMetrics(Object.values(this.metrics));
  }
}
